import { Card, Flex, Typography } from 'antd'
import { Key, ShieldCheck } from 'lucide-react'
import { useTranslation } from 'react-i18next'

import { SectionLabel } from 'src/components'

const { Text, Title } = Typography

const CHIP_PADDING = '10px 12px'

type Props = {
  workspaceRoleCount: number
  customRoleCount: number
  permissionsCount: number
}

const KpiChip = ({
  label,
  value,
  icon,
  iconColor,
  footer
}: {
  label: string
  value: number | string
  icon: React.ReactNode
  iconColor: string
  footer?: string
}) => (
  <Card variant="outlined" styles={{ body: { padding: CHIP_PADDING } }}>
    <Flex align="center" gap={10} style={{ minWidth: 0 }}>
      <span
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: 32,
          height: 32,
          borderRadius: 6,
          background: `${iconColor}14`,
          color: iconColor,
          flex: '0 0 auto'
        }}
      >
        {icon}
      </span>
      <Flex vertical gap={1} style={{ lineHeight: 1.2, minWidth: 0 }}>
        <SectionLabel>{label}</SectionLabel>
        <Flex align="baseline" gap={6} wrap="wrap">
          <Title
            level={5}
            style={{
              margin: 0,
              fontSize: 16,
              lineHeight: 1.1,
              fontWeight: 600,
              fontVariantNumeric: 'tabular-nums'
            }}
          >
            {value}
          </Title>
          {footer ? (
            <Text type="secondary" style={{ fontSize: 11 }}>
              {footer}
            </Text>
          ) : null}
        </Flex>
      </Flex>
    </Flex>
  </Card>
)

export const RolesKpiChips = ({
  workspaceRoleCount,
  customRoleCount,
  permissionsCount
}: Props) => {
  const { t } = useTranslation()

  return (
    <Flex gap={8} wrap="wrap">
      <KpiChip
        label={t('workspace.orgRoles.kpi.workspaceRoles')}
        value={workspaceRoleCount}
        icon={<ShieldCheck size={16} />}
        iconColor="#0F766E"
        footer={`${customRoleCount} ${t('workspace.orgRoles.kpi.customRoles')}`}
      />
      <KpiChip
        label={t('workspace.orgRoles.kpi.permissionsCatalog')}
        value={permissionsCount}
        icon={<Key size={16} />}
        iconColor="#7C3AED"
      />
    </Flex>
  )
}
